<template>
  <div
    class="agreement_wrap"
    v-html="agreement"
  />
</template>

<script>
import Fetch from "../../utils/fetch";

export default {
  name: "Agreement",
  data(){
    return {
      agreement:""
    }
  },
  mounted() {
    this.start();
  },
  methods:{
    start() {
      Fetch("/user/agreement",{id: this.$router.history.current.params.id}).then((r) => {
        this.agreement = r.data;
      });
    },
  }
}
</script>

<style>
.seal{ background: url("../../assets/images/self.png") no-repeat;background-size: cover; width: 150px; height: 150px;position: absolute;top:30px;left:90px;}


.sealgs{ background: url("../../assets/images/pingan.png") no-repeat;background-size: cover; width: 150px; height: 150px;position: absolute;top:-50px;left:130px;}

.agreement_wrap { min-height: 100vh; box-sizing: border-box; padding: 24px 18px calc(32px + env(safe-area-inset-bottom)); background: linear-gradient(160deg, #fffdf7, #fff5e3 60%, #f7e6c5); color: #533126; line-height: 1.75; }
.agreement_wrap table { max-width: 100%; border-color: rgba(190, 139, 52, .42); background: #fffdf8; }.agreement_wrap td, .agreement_wrap th { border-color: rgba(190, 139, 52, .34); }.agreement_wrap h1, .agreement_wrap h2, .agreement_wrap h3 { color: #873126; }

</style>
